import { useIntl } from 'react-intl';
import { KeyboardShortcut } from '@rossum/components/keyboard-shortcut/KeyboardShortcut';
import { IconCircleCheck } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';

type ConfirmButtonProps = {
  disabled?: boolean;
  onClick: () => void;
  keyName?: 'tab';
};

export const ConfirmButton = ({
  disabled,
  onClick,
  keyName,
}: ConfirmButtonProps) => {
  const intl = useIntl();
  return (
    <Tooltip
      key="confirm-button"
      title={
        disabled ? (
          ''
        ) : (
          <KeyboardShortcut
            keyName={keyName}
            description={intl.formatMessage({
              id: 'components.documentValidation.validationDialog.button.confirm.tooltip',
            })}
          />
        )
      }
    >
      <IconButton
        color="success"
        size="medium"
        data-cy="validation-dialog-confirm"
        onClick={onClick}
        disabled={disabled}
        sx={{ p: 0.5, minWidth: 0 }}
      >
        <SvgIcon fontSize="large">
          <IconCircleCheck />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
